/**
 * ProviderResultCard — 写操作完成后的一次性结果卡（设计稿 PayerMax A4 / A5）：`.card` + 成功图标 + 标题，
 * 可选两格 `.stat-*` 统计（参与验签的材料数、旧材料宽限截止）与附加内容；「关闭」后不再显示。
 *
 * 只展示本次写响应里的数，不回读材料本身（材料只写不读）。
 */

import type { ReactNode } from 'react';
import { fmtDateTime } from '~/lib/format';
import { Icons } from '~/lib/icons';

export function MaterialStats({
  verifyingCount,
  retireAfter,
  showFieldNames = false,
}: {
  verifyingCount: number;
  retireAfter: string | null;
  showFieldNames?: boolean;
}) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 12,
        marginTop: 12,
      }}
    >
      <div>
        <div className="stat-label">参与验签的材料</div>
        <div className="stat-value mono" style={{ fontSize: 20, marginTop: 4 }}>
          {verifyingCount}
        </div>
        {showFieldNames && (
          <div className="mono" style={{ fontSize: 11, color: 'var(--fg-muted)' }}>
            verifying_material_count
          </div>
        )}
      </div>
      <div>
        <div className="stat-label">旧材料宽限至</div>
        {retireAfter ? (
          <div className="mono" style={{ fontSize: 14, fontWeight: 600, marginTop: 6 }}>
            {fmtDateTime(retireAfter)}
          </div>
        ) : (
          <div style={{ fontSize: 12.5, marginTop: 6, color: 'var(--fg-muted)' }}>
            没有旧材料在宽限期
          </div>
        )}
        {showFieldNames && (
          <div className="mono" style={{ fontSize: 11, color: 'var(--fg-muted)' }}>
            latest_retiring_retire_after
          </div>
        )}
      </div>
    </div>
  );
}

export function ProviderResultCard({
  title,
  subtitle,
  onDismiss,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  onDismiss: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="card" role="status" style={{ padding: 14 }}>
      <div className="hstack" style={{ gap: 10 }}>
        <span
          style={{
            width: 28,
            height: 28,
            borderRadius: 999,
            background: 'var(--pos-soft)',
            color: 'var(--pos)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icons.IconCheck size={14} />
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 500 }}>{title}</div>
          {subtitle && <div style={{ fontSize: 11.5, color: 'var(--fg-muted)' }}>{subtitle}</div>}
        </div>
        <button
          type="button"
          className="btn btn-ghost btn-icon"
          aria-label="关闭结果"
          onClick={onDismiss}
        >
          <Icons.IconX size={12} />
        </button>
      </div>
      {children}
    </div>
  );
}
